import { render, staticRenderFns } from "./WrsViDate.vue?vue&type=template&id=0cd803fa&"
import script from "./WrsViDate.vue?vue&type=script&lang=js&"
export * from "./WrsViDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports